import React from 'react';
import { IProgressiveLeasingEstimatorData } from '../mfrm-buybox.props.autogenerated';
import {
    IRequestContext
} from '@msdyn365-commerce/core';
import { MfrmProgressiveLeasingEstimator } from './progressive-leasing-estimator';

export const BuyboxProgressiveLeasingEstimator = (
    props: {
        progressiveLeasingEstimator: IProgressiveLeasingEstimatorData,
        productPrice: number,
        ctx: IRequestContext,
        leaseState: boolean
    }
): JSX.Element | null => {
    const {
        progressiveLeasingEstimator,
        productPrice,
        ctx,
        leaseState
    } = props;
    return (
        <MfrmProgressiveLeasingEstimator
            progressiveLeasingEstimator={progressiveLeasingEstimator}
            productPrice={productPrice}
            ctx={ctx}
            isLeaseActive={leaseState}
        />
    );
};
